module.exports = __webpack_public_path__ + "off_ramp_slight_right.svg?be92376cc395d0297af81bcb7aea14da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/off_ramp_slight_right.svg
// module id = 199
// module chunks = 0